import { FormControlLabel, Switch, TextField } from '@mui/material';
import { Stack } from './mui-system';
import type { DailyScheduleSettings } from '../../../api/src/common/daily-schedule.types';

export function DailyScheduleFields({
  value,
  onChange,
  disabled,
  label,
  timeLabel,
}: {
  value: DailyScheduleSettings;
  onChange(value: DailyScheduleSettings): void;
  disabled: boolean;
  label: string;
  timeLabel: string;
}) {
  return (
    <Stack gap={2}>
      <FormControlLabel
        label={label}
        control={
          <Switch
            checked={value.enabled}
            disabled={disabled}
            onChange={(_, enabled) => onChange({ ...value, enabled })}
          />
        }
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={2}>
        <TextField
          label={timeLabel}
          type="time"
          fullWidth
          value={value.collectTime}
          disabled={disabled}
          slotProps={{ inputLabel: { shrink: true } }}
          onChange={(e) => onChange({ ...value, collectTime: e.target.value })}
        />
        <TextField
          label="Часовой пояс"
          fullWidth
          value={value.timeZone}
          disabled={disabled}
          helperText="Например, Europe/Moscow"
          onChange={(e) => onChange({ ...value, timeZone: e.target.value })}
        />
      </Stack>
    </Stack>
  );
}
